import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { httpOptions } from '../../configurations/configuration';
import { environment } from '../../../environments/environment';

export interface ClearCacheRequest {
  paths: string[];
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private readonly clearCachePayload: ClearCacheRequest = {
    paths: ['/*']
  };

  constructor(private http: HttpClient) { }

  clearCache(payload: ClearCacheRequest = this.clearCachePayload): Observable<any> {
    return this.http.post<any>(
      environment.apiURL + environment.clearCacheUrl,
      payload,
      httpOptions
    );
  }
}
